import eurydiceImg from "../assets/eurydice.png";
import loudianaImg from "../assets/loudiana.png";
import melitaeaImg from "../assets/melitaea.png";
import melusineImg from "../assets/melusine.png";
import zamsellyImg from "../assets/zamselly.png";
import { humanizeGemLabel } from "./gems";

export const MIN_KEY_LEVEL = 2;
export const KEY_MIN_LEVEL_NOTE = "Niveau 2 minimum.";

export const FAIRY_KEYS = [
  {
    id: "melusine",
    name: "Mélusine",
    obtainArticle: "un",
    image: melusineImg,
    themeClass: "key-card--melusine",
    confettiColor: "#b91c1c",
    description:
      "Le jeu contiendra uniquement des mots non découverts. Niveau 2 minimum.",
    confettiAnimationDelay: 0,
    confettiAnimationSpeed: 0.45,
    confettiAnimationPause: 3200,
    minLevel: MIN_KEY_LEVEL,
    cost: {
      specificGemId: "spinelle",
      specificGemCount: 1,
      commonGemCount: 15,
    },
  },
  {
    id: "loudiana",
    name: "Loudiana",
    obtainArticle: "un",
    image: loudianaImg,
    themeClass: "key-card--loudiana",
    confettiColor: "#6BFF4A",
    description:
      "Le jeu contiendra uniquement des mots qui ont été joués une fois ou deux. Niveau 2 minimum.",
    confettiAnimationDelay: 480,
    confettiAnimationSpeed: 0.45,
    confettiAnimationPause: 4800,
    minLevel: MIN_KEY_LEVEL,
    cost: {
      specificGemId: "émeraude",
      specificGemCount: 1,
      commonGemCount: 15,
    },
  },
  {
    id: "eurydice",
    name: "Eurydice",
    obtainArticle: "un",
    image: eurydiceImg,
    themeClass: "key-card--eurydice",
    confettiColor: "#22d3ee",
    description:
      "Le jeu contiendra uniquement des mots dont la gradation est inférieure à B+. Niveau 2 minimum.",
    confettiAnimationDelay: 960,
    confettiAnimationSpeed: 0.45,
    confettiAnimationPause: 6200,
    minLevel: MIN_KEY_LEVEL,
    cost: {
      specificGemId: "diamant",
      specificGemCount: 1,
      commonGemCount: 15,
    },
  },
  {
    id: "zamselly",
    name: "Zamselly",
    obtainArticle: "un",
    image: zamsellyImg,
    themeClass: "key-card--zamselly",
    confettiColor: "#f97316",
    description:
      "Chaque question de la partie se joue avec 50 secondes au lieu de 25. Niveau 2 minimum.",
    confettiAnimationDelay: 1440,
    confettiAnimationSpeed: 0.45,
    confettiAnimationPause: 7600,
    minLevel: MIN_KEY_LEVEL,
    cost: {
      specificGemId: "saphir",
      specificGemCount: 1,
      commonGemCount: 10,
    },
  },
  {
    id: "melitaea",
    name: "Melitaea",
    obtainArticle: "un",
    image: melitaeaImg,
    themeClass: "key-card--melitaea",
    confettiColor: "#2F5D3A",
    description:
      "Le jeu contiendra uniquement des mots qui n'ont pas été joués depuis plus de 7 jours. Niveau 2 minimum.",
    confettiAnimationDelay: 0,
    confettiAnimationSpeed: 0.45,
    confettiAnimationPause: 3200,
    minLevel: MIN_KEY_LEVEL,
    cost: {
      specificGemId: "péridot",
      specificGemCount: 1,
      commonGemCount: 10,
    },
  },
];

export const KEY_COLLECTION_PAGES = [
  ["melusine", "loudiana", "eurydice", "zamselly"],
  ["melitaea"],
];

const keysById = new Map(FAIRY_KEYS.map((key) => [key.id, key]));

export function getKeyById(keyId) {
  return keysById.get(keyId) ?? null;
}

export function getKeyPowerPreposition(keyName) {
  const trimmed = String(keyName || "").trim();
  if (!trimmed) return "de ";

  const firstLetter = trimmed
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .charAt(0)
    .toLowerCase();

  return /^[aeiouy]/.test(firstLetter) ? "d'" : "de ";
}

export const KEY_POWER_GAME_MESSAGES = {
  melusine:
    "Pouvoir du parchemin Mélusine : la partie se joue sur des mots non découverts uniquement.",
  loudiana:
    "Pouvoir du parchemin Loudiana : la partie se joue sur des mots joués 1 ou 2 fois uniquement.",
  eurydice:
    "Pouvoir du parchemin Eurydice : la partie se joue sur des mots gradés sous B+ uniquement.",
  zamselly:
    "Pouvoir du parchemin Zamselly : vous disposez de 50 secondes par question pour toute la partie.",
  melitaea:
    "Pouvoir du parchemin Melitaea : la partie se joue sur des mots non joués depuis plus de 7 jours uniquement.",
};

export function getKeyPowerGameMessage(keyId) {
  return KEY_POWER_GAME_MESSAGES[keyId] ?? null;
}

export function getKeyCardDescriptionBody(key) {
  return key.description
    .replace(/\s*Niveau 2 minimum\.?\s*$/i, "")
    .trim();
}

function formatGemName(gemId, count) {
  const label = humanizeGemLabel(`${gemId}.png`).toLocaleLowerCase("fr-FR");
  if (count <= 1) return `1 ${label}`;
  if (label === "rubis") return `${count} rubis`;
  if (label.endsWith("s")) return `${count} ${label}`;
  return `${count} ${label}s`;
}

export function formatKeyObtainTitle(key) {
  const article = key.obtainArticle ?? "une";
  return `Obtenir ${article} parchemin ${key.name}`;
}

export function formatKeyCostLines(key) {
  const { specificGemId, specificGemCount, commonGemCount } = key.cost;
  const specificPart = formatGemName(specificGemId, specificGemCount);
  const commonLabel =
    commonGemCount > 1 ? `${commonGemCount} pierres communes` : "1 pierre commune";
  return {
    specificPart,
    commonPart: `ou ${commonLabel}`,
  };
}
